import { MONTHLY_PLAN_IDS } from '@/constants/plans';

import { webCampaign } from '../modules/webCampaign';

import { useUserStore } from './useAccount';
import { useQueryStripeV2Prices } from './useQueryStripeV2Prices.ts';

export const useStripeV2Plans = () => {
  const selectedPlanId = useUserStore((store) => store.selectedPlanId);
  const selectedCoinPlanId = useUserStore((store) => store.selectedCoinPlanId);
  const user = useUserStore((store) => store.user);

  const onboardingGender = user?.onboarding_data?.gender as
    | 'male'
    | 'female'
    | undefined;
  const onboardingIdentify = user?.onboarding_data?.identify;
  const campaignPlans = webCampaign.getPlans(
    onboardingGender,
    onboardingIdentify,
  );
  const campaignCoins = webCampaign.getCoins();

  const { subscriptions, coins, isLoading, isSuccess, billingPortalLink } =
    useQueryStripeV2Prices({
      subscriptions: campaignPlans,
      coins: campaignCoins,
    });

  const sortedSubscriptions = subscriptions.sort((a, b) => {
    const indexA = campaignPlans.indexOf(a.id);
    const indexB = campaignPlans.indexOf(b.id);
    return indexA - indexB;
  });

  const selectedPlan = sortedSubscriptions.find(
    (plan) => plan.id === selectedPlanId,
  );
  const selectedCoinPlan = coins.find((coin) => coin.id === selectedCoinPlanId);

  const monthlyPlan = sortedSubscriptions.find((plan) =>
    MONTHLY_PLAN_IDS.includes(plan.id as (typeof MONTHLY_PLAN_IDS)[number]),
  );

  const checkIsPlanActive = (planId: string) => {
    return selectedPlanId === planId;
  };

  return {
    isLoadingPlans: isLoading,
    selectedPlan,
    selectedCoinPlan,
    stripePlans: sortedSubscriptions,
    monthlyPlan,
    checkIsPlanActive,
    isSuccess,
    billingPortalLink,
    coinsPlans: coins,
  };
};
